// A shape wrapping an ICurve delegate, providing additional information.
import { Shape } from './shape';
export class RelativeShape extends Shape {
    get BoundaryCurve() {
        return this.node.boundaryCurve;
    }
    set BoundaryCurve(value) {
        if (value)
            throw new Error('Cannot set BoundaryCurve directly for RelativeShape');
    }
    // Constructor taking the ID and the curve delegate for the shape.
    constructor(node) {
        super(null);
        this.node = node;
    }
}
//# sourceMappingURL=RelativeShape.js.map